import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import TTFont from "../assets/fonts/TT Ramillas Trial Regular.ttf";
import mobBanner from "../assets/April-mob.jpg";
import desktopBanner from "../assets/April-web.jpg";

// import { useNavigate } from "react-router-dom";

const Usa = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenReg, setIsOpenReg] = useState(false);
  const [isOpenAcco, setIsOpenAcco] = useState(false);
  const [isOpenAccoTwo, setIsOpenAccoTwo] = useState(false);
  // const navigate = useNavigate();

  const [imagesLarge, setImagesLarge] = useState([
    "https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/07/Glory-of-Jainism_Paryushan-2024.jpg?x74762",
    "https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/07/Ritual-to-Spiritual-Youth_Paryushan-2024.jpg?x74762",
  ]);

  const [imagesLarge2, setImagesLarge2] = useState([
    "https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/07/SRD-Musical_Paryushan-2024.jpg?x74762",
    "https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/07/SRLC-Eve_Paryushan-2024.jpg?x74762",
  ]);

  const imagesSmall = [...imagesLarge, ...imagesLarge2];

  // const meditationImage =
  //   "https://d20iun51fib1lt.cloudfront.net/Yoga_Banner_USA_837989fd9a.jpg";

  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 7000,
    arrows: false,
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const response = await fetch(
          `https://strapi.srmd.org/api/usa-shilanyas-2025?populate[0]=introduction.registerButton&populate[1]=schedule.scheduleLineItem&populate[2]=schedule.scheduleTableTitles&populate[3]=registration.registrationLineItem&populate[4]=accomodations.onSiteAccommodations&populate[5]=accomodations.onSiteLineItems&populate[6]=accomodations.hotelDetails&populate[7]=accomodations.onSiteLineItems&populate[8]=accomodations.hotelDetails&populate[9]=additionalInformation&populate[10]=sponsorshipInfo.sponsorshipLineItem&populate[11]=contactDetails&populate[12]=Banner&populate[13]=PPGIntroduction&populate[14]=eventDetails&populate[15]=registrationProcess.listItems`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${process.env.REACT_APP_USA_API_TOKEN}`,
            },
          }
        );
        if (!response.ok) {
          setLoading(false);
          throw new Error("Failed to fetch data");
        }

        const result = await response.json();
        setData(result.data); // Storing only the 'data' object
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        setLoading(false);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (data?.eventDetails) {
      setImagesLarge(data?.eventDetails?.details[0]?.carousel);
      setImagesLarge2(data?.eventDetails?.details[1]?.carousel);
    }
  }, [data]);

  return (
    <div class="bg-[#fff9f1]">
      {data?.Banner && (
        <>
          <img
            src={desktopBanner}
            alt={data?.Banner?.altText}
            class="hidden md:block w-full h-auto object-cover"
          />
          <img
            src={mobBanner}
            alt={data?.Banner?.altText}
            class="block md:hidden w-full h-auto object-cover"
          />
        </>
      )}
      {!loading && (
        <div class="flex px-1 sm:px-36 py-5 gap-2 flex-nowrap justify-start sm:justify-center items-center border-t border-gray-200 overflow-x-auto whitespace-nowrap ">
          <a
            href="#Schedule"
            class="text-center text-[17px] font-bold block  text-[#384f31] hover:text-[#e1bcb6]"
          >
            Schedule
            <span className="text-[#e1bcb6] text-[24px] ml-2">|</span>
          </a>
          <a
            href="#Registration"
            class=" text-center  text-[17px] font-bold block  text-[#384f31] hover:text-[#e1bcb6]"
          >
            Registration
            <span className="text-[#e1bcb6] text-[24px] ml-2">|</span>
          </a>
          <a
            href="#Accommodations"
            class=" text-center  text-[17px] font-bold block  text-[#384f31] hover:text-[#e1bcb6]"
          >
            Accommodations
            <span className="text-[#e1bcb6] text-[24px] ml-2">|</span>
          </a>{" "}
          <a
            href="#Additional-Information"
            class="text-center  text-[17px] font-bold block  text-[#384f31] hover:text-[#e1bcb6] "
          >
            Additional Information
            <span className="text-[#e1bcb6] text-[24px] ml-2">|</span>
          </a>{" "}
          <a
            href="#laabhs"
            class=" text-center  text-[17px] font-bold block  text-[#384f31] hover:text-[#e1bcb6] "
          >
            Laabhs
            <span className="text-[#e1bcb6] text-[24px] ml-2">|</span>
          </a>{" "}
          <a
            href="#Contact"
            class="text-center  text-[17px] font-bold block  text-[#384f31] hover:text-[#e1bcb6]"
          >
            Contact
            <span className="text-[#e1bcb6] text-[24px] ml-2 invisible">|</span>
          </a>{" "}
        </div>
      )}
      {loading && (
        <div className="flex justify-center items-center py-2 min-h-[100vh]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="5.5em"
            height="5.5em"
            viewBox="0 0 24 24"
          >
            <path
              fill="#e1bcb6"
              d="M20.27,4.74a4.93,4.93,0,0,1,1.52,4.61,5.32,5.32,0,0,1-4.1,4.51,5.12,5.12,0,0,1-5.2-1.5,5.53,5.53,0,0,0,6.13-1.48A5.66,5.66,0,0,0,20.27,4.74ZM12.32,11.53a5.49,5.49,0,0,0-1.47-6.2A5.57,5.57,0,0,0,4.71,3.72,5.17,5.17,0,0,1,9.53,2.2,5.52,5.52,0,0,1,13.9,6.45,5.28,5.28,0,0,1,12.32,11.53ZM19.2,20.29a4.92,4.92,0,0,1-4.72,1.49,5.32,5.32,0,0,1-4.34-4.05A5.2,5.2,0,0,1,11.6,12.5a5.6,5.6,0,0,0,1.51,6.13A5.63,5.63,0,0,0,19.2,20.29ZM3.79,19.38A5.18,5.18,0,0,1,2.32,14a5.3,5.3,0,0,1,4.59-4,5,5,0,0,1,4.58,1.61,5.55,5.55,0,0,0-6.32,1.69A5.46,5.46,0,0,0,3.79,19.38ZM12.23,12a5.11,5.11,0,0,0,3.66-5,5.75,5.75,0,0,0-3.18-6,5,5,0,0,1,4.42,2.3,5.21,5.21,0,0,1,.24,5.92A5.4,5.4,0,0,1,12.23,12ZM11.76,12a5.18,5.18,0,0,0-3.68,5.09,5.58,5.58,0,0,0,3.19,5.79c-1,.35-2.9-.46-4-1.68A5.51,5.51,0,0,1,11.76,12ZM23,12.63a5.07,5.07,0,0,1-2.35,4.52,5.23,5.23,0,0,1-5.91.2,5.24,5.24,0,0,1-2.67-4.77,5.51,5.51,0,0,0,5.45,3.33A5.52,5.52,0,0,0,23,12.63ZM1,11.23a5,5,0,0,1,2.49-4.5,5.23,5.23,0,0,1,5.81-.06,5.3,5.3,0,0,1,2.61,4.74A5.56,5.56,0,0,0,6.56,8.06,5.71,5.71,0,0,0,1,11.23Z"
            >
              <animateTransform
                attributeName="transform"
                dur="1.5s"
                repeatCount="indefinite"
                type="rotate"
                values="0 12 12;360 12 12"
              />
            </path>
          </svg>
        </div>
      )}
      {data?.introduction && !loading && (
        <div className="px-0 sm:px-36 pt-5 pb-10">
          <div className="mx-auto text-center pb-10">
            {/* <div className="mt-2 px-0 md:px-28 w-full flex flex-col md:flex-row gap-2 justify-center items-stretch">
              {[
                {
                  title: "Shilanyas & Natak Samaysaar Shibir",
                  date: "Fri, 18 - Sun, 20 April, 2025",
                  route: "/default-route",
                },
                {
                  title: "Non Shibir Weekday Registrations",
                  date: "Mon, 21 - Fri, 25 April, 2025",
                  route: "/default-route",
                },
                {
                  title: "Wellness Retreat with Pujya Gurudevshri Rakeshji",
                  date: "Fri, 25 - Sun, 27 April, 2025",
                  route: "/usa/wellnessRetreat",
                },
              ].map((event, index) => (
                <div
                  key={index}
                  className="flex-1 bg-[#384f31] text-[#fff9f1] font-bold py-4 px-6 rounded-md hover:bg-[#e1bcb6] flex flex-col justify-between min-h-[160px]"
                >
                  <div>
                    {event.title}
                    <br />
                    <span className="whitespace-nowrap">{event.date}</span>
                  </div>
                  <button
                    onClick={() => navigate(event.route)}
                    className="inline-block mt-4 p-2 bg-[#fff9f1] hover:bg-[#384f31] text-[#384f31] hover:text-[#fff9f1] font-bold rounded-md text-center"
                  >
                    View Details
                  </button>
                </div>
              ))}
            </div> */}
            <h2
              className="text-5xl font-medium text-[#d1980b]"
              style={{
                fontFamily: "TT Ramillas, serif",
                src: `url(${TTFont})`,
              }}
            >
              {data?.introduction?.title?.split(":")[0]}
              <br />
              {data?.introduction?.title?.split(":")[1]}
            </h2>
            {/* <p
              className="italic text-lg text-[#384f31] mt-2"
              style={{ fontFamily: "'Crimson Pro', serif" }}
            >
              {data?.introduction?.subTitle}
            </p> */}
            <p className="text-gray-700 text-lg font-semibold mt-4">
              {data?.introduction?.description?.split("\n")[0]}
            </p>
            <p className="text-gray-700 text-lg font-semibold mt-2">
              {data?.introduction?.description?.split("\n")[1]}
            </p>
            <p className="text-[#384f31] font-bold text-2xl mt-2">
              {data?.introduction?.description?.split("\n")[2]}
            </p>
            <p className="text-gray-700 text-lg font-semibold mt-4">
              {data?.introduction?.description?.split("\n")[3]}
            </p>
            {data?.introduction?.registerButton && (
              <>
                <div className="mt-6">
                  <a
                    href={"https://register.srmd.org/events/BP2501"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-block bg-[#384f31] text-[#fff9f1] font-bold py-2 px-6 rounded-full hover:bg-[#e1bcb6]"
                  >
                    {data?.introduction?.registerButton?.buttonText}
                  </a>
                </div>
              </>
            )}
          </div>
        </div>
      )}
      {/* {data?.PPGIntroduction && !loading && (
        <div
          className="bg-[#384f31] text-[#e4ae5b] px-8 pt-8  
  md:bg-[url('https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/07/bround_bapu_bg-1.jpg?x74762')] md:bg-cover md:bg-center"
        >
          <div className="max-w-4xl mx-auto flex flex-col md:flex-row items-center">
            <div className="md:w-1/2">
              <h1 className="text-2xl md:text-4xl font-bold mb-4">
                {data?.PPGIntroduction?.title}
              </h1>
              <img
                src="https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/07/gold-shape.png?x74762"
                alt="Gold Style"
                className="mb-4"
              />

              <p
                className="text-lg md:text-xl py-4"
                dangerouslySetInnerHTML={{ __html: data?.PPGIntroduction.body }}
              ></p>
            </div>
            <div className="block md:hidden md:w-1/2 mt-8 md:mt-2 ">
              <img
                src="https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/07/bapa_intro_M.jpg?x74762"
                alt="Pujya Gurudevshri Rakeshji"
                className=""
              />
            </div>
          </div>
        </div>
      )} */}
      {!loading && (
        <div
          className="relative w-full flex flex-col items-center py-10"
          style={{
            backgroundImage: `linear-gradient(1deg,#fff9f1,#fff9f1,#95b199)`,
          }}
        >
          <h1
            className="text-[#384f31] text-3xl md:text-5xl font-bold mb-4 pt-5"
            style={{ fontFamily: "'Crimson Pro', serif" }}
          >
            Highlights
          </h1>
          <img
            src="https://d3fzplfbemxxxv.cloudfront.net/wp-content/uploads/2024/07/Title-Bottom-Motif.svg.gzip?x74762?template=quarter-width"
            alt="Gold Style"
            className="mb-4"
          />

          {/* Large Screen - Two Sliders */}
          <div
            className="hidden md:block w-full max-w-5xl space-y-8"
            style={{
              fontFamily: "'Crimson Pro', serif",
              height: "100%",
              lineHeight: "100%",
            }}
          >
            <div className="flex items-center">
              <Slider {...sliderSettings} className="w-2/3">
                {imagesLarge.map((src, index) => (
                  <div key={index} className="px-2">
                    <img
                      src={src}
                      alt={`Event ${index}`}
                      className="w-full rounded-xl shadow-lg"
                    />
                  </div>
                ))}
              </Slider>
              <div className="w-1/3 pl-6 text-[#384f31]">
                <h3 className="text-3xl font-semibold">
                  {data?.eventDetails?.details[0]?.events[0]?.title}
                </h3>
                <p className="text-xl italic text-[#384f31]">
                  {data?.eventDetails?.details[0]?.events[0]?.subTitle}
                </p>
                <h3 className="text-3xl font-semibold mt-4">
                  {data?.eventDetails?.details[0]?.events[1]?.title}
                </h3>
                <p className="text-xl italic text-[#384f31]">
                  {data?.eventDetails?.details[0]?.events[1]?.subTitle}
                </p>
              </div>
            </div>

            <div className="flex items-center">
              <div className="w-1/3 pr-6 text-[#384f31]">
                <h3 className="text-3xl font-semibold">
                  {data?.eventDetails?.details[1]?.events[0]?.title}
                </h3>
                <p className="text-xl italic text-[#384f31]">
                  {data?.eventDetails?.details[1]?.events[0]?.subTitle}
                </p>
                <h3 className="text-3xl font-semibold mt-4">
                  {data?.eventDetails?.details[1]?.events[1]?.title}
                </h3>
                <p className="text-xl italic text-[#384f31]">
                  {data?.eventDetails?.details[1]?.events[1]?.subTitle}
                </p>
              </div>
              <Slider {...sliderSettings} className="w-2/3">
                {imagesLarge2.map((src, index) => (
                  <div key={index} className="px-2">
                    <img
                      src={src}
                      alt={`Event ${index}`}
                      className="w-full rounded-xl shadow-lg"
                    />
                  </div>
                ))}
              </Slider>
            </div>
          </div>

          {/* Small Screen - Single Slider */}
          <div
            className="block md:hidden w-full max-w-md text-[#384f31]"
            style={{
              fontFamily: "'Crimson Pro', serif",
              height: "100%",
              lineHeight: "100%",
            }}
          >
            <Slider {...sliderSettings}>
              {imagesSmall.map((src, index) => (
                <div key={index} className="px-2">
                  <img
                    src={src}
                    alt={`Event ${index}`}
                    className="w-full rounded-xl shadow-lg"
                  />
                </div>
              ))}
            </Slider>

            <div className="text-[#384f31] text-center mt-6 space-y-4">
              <h3 className="text-xl font-semibold">
                {data?.eventDetails?.details[0]?.events[0]?.title}
              </h3>
              <p className="text-sm italic text-[#384f31]">
                {data?.eventDetails?.details[0]?.events[0]?.subTitle}
              </p>

              <h3 className="text-xl font-semibold">
                {" "}
                {data?.eventDetails?.details[0]?.events[1]?.title}
              </h3>
              <p className="text-sm italic text-[#384f31]">
                {data?.eventDetails?.details[0]?.events[1]?.subTitle}
              </p>

              <h3 className="text-xl font-semibold">
                {" "}
                {data?.eventDetails?.details[1]?.events[0]?.title}
              </h3>
              <p className="text-sm italic text-[#384f31]">
                {data?.eventDetails?.details[1]?.events[0]?.subTitle}
              </p>

              <h3 className="text-xl font-semibold">
                {data?.eventDetails?.details[1]?.events[1]?.title}
              </h3>
              <p className="text-sm italic text-[#384f31]">
                {data?.eventDetails?.details[1]?.events[1]?.subTitle}
              </p>
            </div>
          </div>

          {/* Meditation Image */}
          {/* <div
            className="w-full   mt-8 relative"
            style={{ fontFamily: "'Crimson Pro', serif" }}
          >
            <h3 className="absolute top-1/2 left-1/2  transform -translate-x-1/2 -translate-y-1/2 text-[#fff9f1] text-xl sm:text-5xl font-semibold text-center rounded-md whitespace-nowrap">
              Yoga Retreat
              <br />
              April 25-27
              <br />
              <div className="mt-2 sm:mt-0">
                <a
                  href={data?.introduction?.registerButton?.buttonLink}
                  className="inline-block text-sm sm:text-xl bg-[#384f31] text-[#fff9f1] font-bold py-1 sm:py-2 px-2 sm:px-6 rounded-full hover:bg-[#e1bcb6] hover:text-[#384f31]"
                >
                  {data?.introduction?.registerButton?.buttonText}
                </a>
              </div>
            </h3>
            <img
              src={meditationImage}
              alt="Sound Bath Meditation and Chanting"
              className="w-full rounded-xl shadow-lg object-cover"
            />
          </div> */}
        </div>
      )}
      {!loading && (
        <div className="px-0 sm:px-36">
          {data?.schedule && !loading && (
            <div
              id="Schedule"
              className="bg-[#fff9f1] p-2 sm:p-8 overflow-x-auto"
            >
              <div
                className="flex justify-between items-center cursor-pointer text-[#384f31]"
                onClick={() => setIsOpen(!isOpen)}
              >
                <h2 className="text-xl font-bold  mb-4">Schedule</h2>
                <span className="block md:hidden mb-4">
                  {isOpen ? (
                    <svg
                      height="24"
                      viewBox="0 0 48 48"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      className="fill-current"
                    >
                      <path d="M14.83 30.83l9.17-9.17 9.17 9.17 2.83-2.83-12-12-12 12z" />
                      <path d="M0 0h48v48h-48z" fill="none" />
                    </svg>
                  ) : (
                    <svg
                      height="24"
                      viewBox="0 0 48 48"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      className="fill-current"
                    >
                      <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" />
                      <path d="M0-.75h48v48h-48z" fill="none" />
                    </svg>
                  )}
                </span>
              </div>
              <table className="hidden md:table w-full border  border-black">
                <thead>
                  <tr className="bg-[#384f31] text-[#fff9f1]">
                    {data?.schedule?.scheduleTableTitles.map((item) => (
                      <th
                        key={item.id}
                        className="py-2 px-4 border border-black whitespace-nowrap"
                      >
                        {item?.title}
                        <br />
                        {item?.subTitle}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody className="text-black">
  {data?.schedule.scheduleLineItem.map((item) => (
    <tr key={item.id} className="text-center border-black">
      <td className="py-2 px-4 border border-black whitespace-nowrap">
        {item.date}
      </td>

      <td className="py-2 px-4 border border-black">
        {item?.earlyMorningTitle?.split("/n").map((line, index, arr) => (
          <React.Fragment key={index}>
            {line}
            {index !== arr.length - 1 && <br />}
          </React.Fragment>
        ))}
      </td>

      <td className="py-2 px-4 border border-black">
        {item?.morningEvent?.split("/n").map((line, index, arr) => (
          <React.Fragment key={index}>
            {line}
            {index !== arr.length - 1 && <br />}
          </React.Fragment>
        ))}
      </td>

      <td className="py-2 px-4 border border-black">
        {item?.afternoonEvent?.split("/n").map((line, index, arr) => (
          <React.Fragment key={index}>
            {line}
            {index !== arr.length - 1 && <br />}
          </React.Fragment>
        ))}
      </td>

      <td className="py-2 px-4 border border-black">
        {item?.eveningEvent?.split("/n").map((line, index, arr) => (
          <React.Fragment key={index}>
            {line}
            {index !== arr.length - 1 && <br />}
          </React.Fragment>
        ))}
      </td>

      <td className="py-2 px-4 border border-black">
        {item.dressCode}
      </td>
    </tr>
  ))}
</tbody>
              </table>
              {isOpen && (
                <div className="flex md:hidden  flex-col">
                  {data?.schedule.scheduleLineItem.map((item, index) => (
                    <div
                      key={item.id}
                      className="border border-black text-center text-[#384f31]"
                    >
                      <h1 className="bg-[#384f31] text-[#fff9f1] py-2 text-lg font-semibold">
                        {data?.schedule.scheduleTableTitles[0]?.title}
                        {data?.schedule.scheduleTableTitles[0]?.subTitle}
                      </h1>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        {item.date}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.schedule.scheduleTableTitles[1]?.title}
                        </strong>
                        <br />
                        {item?.earlyMorningTitle?.split("/n").map((line, index, arr) => (
          <React.Fragment key={index}>
            {line}
            {index !== arr.length - 1 && <br />}
          </React.Fragment>
        ))}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.schedule.scheduleTableTitles[2]?.title}
                        </strong>
                        <br />
                        {item?.morningEvent?.split("/n").map((line, index, arr) => (
          <React.Fragment key={index}>
            {line}
            {index !== arr.length - 1 && <br />}
          </React.Fragment>
        ))}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.schedule.scheduleTableTitles[3]?.title}
                        </strong>
                        <br />
                        {item?.afternoonEvent?.split("/n").map((line, index, arr) => (
          <React.Fragment key={index}>
            {line}
            {index !== arr.length - 1 && <br />}
          </React.Fragment>
        ))}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.schedule.scheduleTableTitles[4]?.title}
                        </strong>
                        <br />
                        {item?.eveningEvent?.split("/n").map((line, index, arr) => (
          <React.Fragment key={index}>
            {line}
            {index !== arr.length - 1 && <br />}
          </React.Fragment>
        ))}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold ">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.schedule.scheduleTableTitles[5]?.title}
                        </strong>
                        <br /> {item.dressCode}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          )}
          {!loading && data?.registrationProcess[0] && (
            <div className="p-2 sm:p-8 overflow-x-auto">
              <h2 className="text-xl font-bold  mb-2">Registration Process</h2>
              <ul className="list-disc  text-black">
                {data?.registrationProcess?.map((process, index) => (
                  <div key={process.id}>
                    <strong className="inline-block mt-2">
                      {process?.title} -
                    </strong>
                    <span className="inline">
                      {process?.listItems[0]?.value
                        ?.split("\n")
                        .filter((line) => line.trim() !== "") // Remove empty lines
                        .map((item, itemIndex) => (
                          <span className="inline" key={itemIndex}>
                            {" "}{item}
                          </span>
                        ))}
                    </span>
                  </div>
                ))}
              </ul>
            </div>
          )}
          {data?.registration && !loading && (
            <div
              id="Registration"
              className="bg-[#fff9f1] p-2 sm:p-8 overflow-x-auto"
            >
              <div
                className="flex justify-between items-center cursor-pointer text-[#384f31]"
                onClick={() => setIsOpenReg(!isOpenReg)}
              >
                <h2 className="text-xl font-bold  mb-4">Registration</h2>
                <span className="block md:hidden mb-4">
                  {isOpenReg ? (
                    <svg
                      height="24"
                      viewBox="0 0 48 48"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      className="fill-current"
                    >
                      <path d="M14.83 30.83l9.17-9.17 9.17 9.17 2.83-2.83-12-12-12 12z" />
                      <path d="M0 0h48v48h-48z" fill="none" />
                    </svg>
                  ) : (
                    <svg
                      height="24"
                      viewBox="0 0 48 48"
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      className="fill-current"
                    >
                      <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" />
                      <path d="M0-.75h48v48h-48z" fill="none" />
                    </svg>
                  )}
                </span>
              </div>
              <table className="hidden md:table w-full border  border-black">
                <thead>
                  <tr className="bg-[#384f31] text-[#fff9f1]">
                    <th className="py-2 px-4 border border-black">
                      {data?.registration.registrationTitle}
                    </th>
                    <th className="py-2 px-4 border border-black whitespace-nowrap">
                      {data?.registration?.slab1Title?.split(" (")[0]}
                      <br />
                      {`(${data?.registration?.slab1Title?.split(" (")[1]}`}
                    </th>
                    <th className="py-2 px-4 border border-black whitespace-nowrap">
                      {data?.registration?.slab2Title?.split(" (")[0]}
                      <br />
                      {`(${data?.registration?.slab2Title?.split(" (")[1]}`}
                    </th>
                    <th className="py-2 px-4 border border-black whitespace-nowrap">
                      {data?.registration?.slab3Title?.split(" (")[0]}
                      <br />
                      {`(${data?.registration?.slab3Title?.split(" (")[1]}`}
                    </th>
                    <th className="py-2 px-4 border border-black whitespace-nowrap">
                      {data?.registration?.slab4Title?.split(" (")[0]}
                      <br />
                      {`(${data?.registration?.slab4Title?.split(" (")[1]}`}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.registration.registrationLineItem.map((item) => (
                    <tr key={item.id} className="text-center  border-black">
                      <td className="py-2 px-4 border  border-black">
                        {item.registration?.split(" (")[0]}
                        <br />
                        {`(${item.registration?.split(" (")[1]}`}

                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.slab1Price}

                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.slab2Price}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.slab3Price}
                      </td>
                      <td className="py-2 px-4 border  border-black">
                        {item.slab4Price}
                      </td>
                    </tr>
                  ))}
                  <tr className="text-center  border-black">
                    <td className="py-2 px-4 border  border-black">
                      {data?.registration.registrationLinkText}
                    </td>
                    <td colSpan="4" className="py-2 px-4 border border-black">
                      <a
                        href={data.registration.registrationLink}
                        className="text-[#384f31] hover:underline"
                      >
                        {data.registration.registrationLinkText}
                      </a>
                    </td>
                  </tr>
                  <tr className="text-center  border-black">
                    <td className="py-2 px-4 border  border-black">
                      {data?.registration.cancellationPolicyText}
                    </td>
                    <td colSpan="4" className="py-2 px-4 border border-black">
                      {data.registration.cancellationPolicyDetail?.split("\\n")[0]}
                      <br />
                      {data.registration.cancellationPolicyDetail?.split("\\n")[1]}
                    </td>
                  </tr>
                </tbody>
              </table>
              {isOpenReg && (
                <div className="flex md:hidden  flex-col">
                  {data?.registration.registrationLineItem.map((item) => (
                    <div
                      key={item.id}
                      className="border border-black text-center text-[#384f31]"
                    >
                      <h2 className="bg-[#384f31] text-[#fff9f1] py-2 text-lg font-semibold">
                        {item.registration}
                      </h2>
                      <p className="py-2 border-b border-black text-lg font-semibold">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.registration.slab1Title}
                        </strong>
                        <br /> {item.slab1Price}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.registration.slab2Title}
                        </strong>
                        <br /> {item.slab2Price}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.registration.slab3Title}
                        </strong>
                        <br /> {item.slab3Price}
                      </p>
                      <p className="py-2 border-b border-black text-lg font-semibold">
                        <strong className="mb-2 inline-block text-lg font-semibold text-black">
                          {data?.registration.slab4Title}
                        </strong>
                        <br /> {item.slab4Price}
                      </p>
                    </div>
                  ))}
                  <div className="border border-black text-center">
                    <h1 className="bg-[#384f31] text-[#fff9f1] py-2 text-lg font-semibold">
                      {data?.registration.registrationLinkText}
                    </h1>
                    <p className="py-2 border-b border-black text-lg font-semibold">
                      <a
                        href={data.registration.registrationLink}
                        className="text-[#384f31] hover:underline"
                      >
                        {data.registration.registrationLinkText}
                      </a>
                    </p>
                  </div>
                  <div className="border border-black text-center">
                    <h1 className="bg-[#384f31] text-[#fff9f1] py-2 text-lg font-semibold">
                      {data?.registration.cancellationPolicyText}
                    </h1>
                    <p className="py-2 px-2 border-b border-black text-lg font-semibold">
                      {data.registration.cancellationPolicyDetail?.split("\\n")[0]}
                      <br />
                      {data.registration.cancellationPolicyDetail?.split("\\n")[1]}
                    </p>
                  </div>
                </div>
              )}
            </div>
          )}

          {data?.accomodations && !loading && (

            <div id="Accommodations" className="bg-[#fff9f1] p-2 sm:p-8">
              <h2 className="text-xl font-bold text-[#384f31] mb-4">
                Accommodations
              </h2>
              <div className="overflow-x-auto">
                <div
                  className="flex justify-between items-center cursor-pointer text-[#384f31]"
                  onClick={() => setIsOpenAcco(!isOpenAcco)}
                >
                  <h3 className="text-md text-gray-600 mb-4">
                    {data?.accomodations?.onSiteTitle}
                  </h3>
                  <span className="block md:hidden mb-4">
                    {isOpenAcco ? (
                      <svg
                        height="24"
                        viewBox="0 0 48 48"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="fill-current"
                      >
                        <path d="M14.83 30.83l9.17-9.17 9.17 9.17 2.83-2.83-12-12-12 12z" />
                        <path d="M0 0h48v48h-48z" fill="none" />
                      </svg>
                    ) : (
                      <svg
                        height="24"
                        viewBox="0 0 48 48"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="fill-current"
                      >
                        <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" />
                        <path d="M0-.75h48v48h-48z" fill="none" />
                      </svg>
                    )}
                  </span>
                </div>

                <table className="hidden md:table w-full border  border-black">
                  <thead>
                    <tr className="bg-[#384f31] text-[#fff9f1]">
                      <th className="py-2 px-4 border border-black">
                        {data?.accomodations.onSiteAccommodations?.onSiteTitle}
                      </th>
                      <th className="py-2 px-4 border border-black">
                        {data?.accomodations.onSiteAccommodations?.slab1Title?.split("\\n")[0]}
                        <br />
                        {data?.accomodations.onSiteAccommodations?.slab1Title?.split("\\n")[1]}
                      </th>
                      <th className="py-2 px-4 border border-black">
                        {data?.accomodations.onSiteAccommodations?.slab2Title?.split("\\n")[0]}
                        <br />
                        {data?.accomodations.onSiteAccommodations?.slab2Title?.split("\\n")[1]}
                      </th>
                      <th className="py-2 px-4 border border-black">
                        {data?.accomodations.onSiteAccommodations?.slab3Title?.split("\\n")[0]}
                        <br />
                        {data?.accomodations.onSiteAccommodations?.slab3Title?.split("\\n")[1]}
                      </th>
                      <th className="py-2 px-4 border border-black">
                        {data?.accomodations.onSiteAccommodations?.slab4Title?.split("\\n")[0]}
                        <br />
                        {data?.accomodations.onSiteAccommodations?.slab4Title?.split("\\n")[1]}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {data?.accomodations.onSiteLineItems.map((item) => (
                      <tr key={item.id} className="text-center border-black">
                        <td className="py-2 px-4 border  border-black whitespace-nowrap ">
                          {item.OnSiteDetail?.split(" (")[0]}
                          <br />{" ("}
                          {item.OnSiteDetail?.split(" (")[1]}
                        </td>
                        <td className="py-2 px-4 border  border-black ">
                          {item.slab1Price?.split("\\n")[0]}
                          <br />
                          {item.slab1Price?.split("\\n")[1]}

                        </td>
                        <td className="py-2 px-4 border  border-black">
                          {item.slab2Price?.split("\\n")[0]}
                          <br />
                          {item.slab2Price?.split("\\n")[1]}
                        </td>
                        <td className="py-2 px-4 border  border-black">
                          {item.slab3Price?.split("\\n")[0]}
                          <br />
                          {item.slab3Price?.split("\\n")[1]}
                        </td>
                        <td className="py-2 px-4 border  border-black">
                          {item.slab4Price?.split("\\n")[0]}
                          <br />
                          {item.slab4Price?.split("\\n")[1]}
                        </td>
                      </tr>
                    ))}

                    <tr className="text-center  border-black">
                      <td className="py-2 px-4 border  border-black">
                        Cancellation Policy
                      </td>
                      <td colSpan="4" className="py-2 px-4 border border-black">
                        {data?.accomodations.onSiteAccommodations
                          ?.cancellationPolicyDetails?.split("\\n")[0]}
                        <br />
                        {data?.accomodations.onSiteAccommodations
                          ?.cancellationPolicyDetails?.split("\\n")[1]}

                      </td>
                    </tr>
                  </tbody>
                </table>
                {isOpenAcco && (
                  <div className="flex md:hidden  flex-col">
                    {data?.accomodations.onSiteLineItems.map((item) => (
                      <div
                        key={item.id}
                        className="border border-black text-center text-[#384f31]"
                      >
                        <h1 className="bg-[#384f31] text-[#fff9f1] py-2 text-lg font-semibold">
                          {item.OnSiteDetail}
                        </h1>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            {data?.accomodations.onSiteAccommodations?.slab1Title?.split("\\n")[0]}
                            <br />
                            {data?.accomodations.onSiteAccommodations?.slab1Title?.split("\\n")[1]}
                          </strong>
                          <br />  {item.slab1Price?.split("\\n")[0]}
                          <br />
                          {item.slab1Price?.split("\\n")[1]}
                        </p>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">

                            {data?.accomodations.onSiteAccommodations?.slab2Title?.split("\\n")[0]}
                            <br />
                            {data?.accomodations.onSiteAccommodations?.slab2Title?.split("\\n")[1]}
                          </strong>
                          <br />  {item.slab2Price?.split("\\n")[0]}
                          <br />
                          {item.slab2Price?.split("\\n")[1]}
                        </p>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            {data?.accomodations.onSiteAccommodations?.slab3Title?.split("\\n")[0]}
                            <br />
                            {data?.accomodations.onSiteAccommodations?.slab3Title?.split("\\n")[1]}

                          </strong>
                          <br />  {item.slab3Price?.split("\\n")[0]}
                          <br />
                          {item.slab3Price?.split("\\n")[1]}
                        </p>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            {data?.accomodations.onSiteAccommodations?.slab4Title?.split("\\n")[0]}
                            <br />
                            {data?.accomodations.onSiteAccommodations?.slab4Title?.split("\\n")[1]}
                          </strong>
                          <br /> {item.slab4Price?.split("\\n")[0]}
                          <br />
                          {item.slab4Price?.split("\\n")[1]}
                        </p>
                      </div>
                    ))}
                    <div className="border border-black text-center">
                      <h1 className="bg-[#384f31] text-[#fff9f1] py-2 text-lg font-semibold">

                        Cancellation Policy
                      </h1>
                      <p className="py-2 px-2 border-b border-black text-lg font-semibold ">
                        {data?.accomodations.onSiteAccommodations
                          ?.cancellationPolicyDetails?.split("\\n")[0]}
                        <br />
                        {data?.accomodations.onSiteAccommodations
                          ?.cancellationPolicyDetails?.split("\\n")[1]}
                      </p>
                    </div>
                  </div>
                )}
              </div>
              <div className="overflow-x-auto">
                <div
                  className="flex justify-between items-center cursor-pointer text-[#384f31]"
                  onClick={() => setIsOpenAccoTwo(!isOpenAccoTwo)}
                >
                  <h3 className="text-md  text-gray-600 mb-4 mt-4">
                    {data.accomodations.hotelAccommodationsTitle}
                  </h3>
                  <span className="block md:hidden mb-4">
                    {isOpenAccoTwo ? (
                      <svg
                        height="24"
                        viewBox="0 0 48 48"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="fill-current"
                      >
                        <path d="M14.83 30.83l9.17-9.17 9.17 9.17 2.83-2.83-12-12-12 12z" />
                        <path d="M0 0h48v48h-48z" fill="none" />
                      </svg>
                    ) : (
                      <svg
                        height="24"
                        viewBox="0 0 48 48"
                        width="24"
                        xmlns="http://www.w3.org/2000/svg"
                        className="fill-current"
                      >
                        <path d="M14.83 16.42l9.17 9.17 9.17-9.17 2.83 2.83-12 12-12-12z" />
                        <path d="M0-.75h48v48h-48z" fill="none" />
                      </svg>
                    )}
                  </span>
                </div>

                <table className="hidden md:table w-full border border-black">
                  <thead>
                    <tr className="bg-[#384f31] text-[#fff9f1]">
                      <th className="py-2 px-4 border border-black">
                        Nearby Hotels
                      </th>
                      {data.accomodations.hotelDetails.map((hotel, index) => (
                        <th
                          key={index}
                          className="py-2 px-4 border border-black"
                        >
                          {hotel.name?.includes("(") ? (
                            <>
                              {hotel.name.split("(")[0]}
                              <br />
                              {`(${hotel.name.split("(")[1]}`}
                            </>
                          ) : (
                            hotel.name
                          )}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="text-center">
                      <td className="py-2 px-4 border border-black">Address</td>
                      {data.accomodations.hotelDetails.map((hotel, index) => (
                        <td
                          key={index}
                          className="py-2 px-4 border border-black"
                        >
                          {hotel.address} <br />({hotel.distance})
                        </td>
                      ))}
                    </tr>
                    <tr className="text-center">
                      <td className="py-2 px-4 border border-black">
                        Hotel Booking
                      </td>
                      {data.accomodations.hotelDetails.map((hotel, index) => (
                        <td
                          key={index}
                          className="py-2 px-4 border border-black"
                        >
                          {hotel.link?.trim() && (
                            <>
                              <a href={hotel.link} className="text-blue-600 hover:underline">
                                [Link]
                              </a>
                            </>
                          )}
                          <br />
                          {hotel.code} <br />
                          {hotel.phone?.includes("\\n") ? (
                            <>
                              {hotel.phone.split("\\n")[0]}
                              <br />
                              {`${hotel.phone.split("\\n")[1]}`}
                            </>
                          ) : (
                            hotel.phone
                          )}
                        </td>
                      ))}
                    </tr>
                    <tr className="text-center">
                      <td className="py-2 px-4 border border-black">
                        Cancellation Policy
                      </td>
                      <td
                        colSpan={data.accomodations.hotelDetails.length}
                        className="py-2 px-4 border border-black"
                      >
                        As Per Hotel Policy
                      </td>
                    </tr>
                  </tbody>
                </table>
                {isOpenAccoTwo && (
                  <div className="flex md:hidden  flex-col">
                    {data.accomodations.hotelDetails.map((item) => (
                      <div
                        key={item.id}
                        className="border border-black text-center text-[#384f31]"
                      >
                        <h1 className="bg-[#384f31] text-[#fff9f1] py-2 text-lg font-semibold">
                          {item.name}
                        </h1>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            Address
                          </strong>
                          <br /> {item.address} <br />({item.distance})
                        </p>
                        <p className="py-2 border-b border-black text-lg font-semibold ">
                          <strong className="mb-2 inline-block text-lg font-semibold text-black">
                            Hotel Booking
                          </strong>
                          <br />{" "}
                          {item.link?.trim() && (
                            <>
                              <a href={item.link} className="text-blue-600 hover:underline">
                                [Link]
                              </a>
                              <br />
                            </>
                          )}
                          {item.code} <br />
                          {item?.phone?.split("/n")[0]}
                          {item?.phone?.includes("/n") && <br />}
                          {item?.phone?.split("/n")[1] &&
                            `${item.phone.split("/n")[1]}`}

                        </p>
                      </div>
                    ))}
                    <div className="border border-black text-center">
                      <h1 className="bg-[#384f31] text-[#fff9f1] py-2 text-lg font-semibold">
                        Cancellation Policy
                      </h1>
                      <p className="py-2 px-2 border-b border-black text-lg font-semibold ">
                        As Per Hotel Policy
                      </p>
                    </div>
                  </div>
                )}
              </div>
            </div>
          )}
          {data?.additionalInformation && !loading && (
            <div
              id="Additional-Information"
              className="bg-[#fff9f1] p-2 sm:p-8 overflow-x-auto"
            >
              <h2 className="text-xl font-bold text-[#384f31] mb-4">
                Additional Information
              </h2>
              <ul className="list-disc pl-5 text-gray-800">
                {data.additionalInformation[0].additionalInformation
                  .split("\n")
                  .map((info, index) => (
                    <li key={index} className="mb-2  text-black">
                      {info.replace(/^- /, "")}
                    </li>
                  ))}
              </ul>
            </div>
          )}
          {data?.sponsorshipInfo && !loading && (
            <div
              id="laabhs"
              className="bg-[#fff9f1] p-2 sm:p-8 overflow-x-auto"
            >
              <h2 className="text-xl font-bold text-[#384f31] mb-2">
                {data?.sponsorshipInfo?.sponsorshipTitle}
              </h2>
              <table className="hidden md:table w-full border border-black mb-4">
                <thead>
                  <tr className="bg-[#384f31] text-[#fff9f1]">
                    <th className="py-2 px-4 border border-black">
                      #
                    </th>

                    <th className="py-2 px-4 border border-black">
                      {data.sponsorshipInfo.sponsorshipTitle}
                    </th>
                    <th className="py-2 px-4 border border-black">
                      {data.sponsorshipInfo.amountTitle}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.sponsorshipInfo?.sponsorshipLineItem.map(
                    (info, index) => (
                      <tr key={index} className="text-center">
                        <td className="py-2 px-4 border border-black">
                          {index + 1}
                        </td>
                        <td className="py-2 px-4 border border-black">
                          {info?.sponsorshipLineItem}
                        </td>
                        <td className="py-2 px-4 border border-black">
                          {info?.amountLineItem}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>
              <table className="table md:hidden w-full border border-black mb-4">
                <thead>
                  <tr className="bg-[#384f31] text-[#fff9f1] py-2 text-lg font-semibold">
                    <th className="py-2 px-4 border border-black">
                      #
                    </th>

                    <th className="py-2 px-4 border border-black">
                      {data.sponsorshipInfo.sponsorshipTitle}
                    </th>
                    <th className="py-2 px-4 border border-black">
                      {data.sponsorshipInfo.amountTitle}
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.sponsorshipInfo?.sponsorshipLineItem.map(
                    (info, index) => (
                      <tr key={index} className="text-center">
                        <td className="py-2 border border-black text-[#384f31] text-lg font-semibold">
                          {index + 1}
                        </td>
                        <td className="py-2 border-b border-black text-lg font-semibold">
                          {info?.sponsorshipLineItem}
                        </td>
                        <td className="py-2 border border-black text-[#384f31] text-lg font-semibold">
                          {info?.amountLineItem}
                        </td>
                      </tr>
                    )
                  )}
                </tbody>
              </table>

              <ul className="list-disc pl-5 text-gray-800" dangerouslySetInnerHTML={{ __html: data?.sponsorshipInfo?.sponsorshipInfo }} />
            </div>
          )}
          {data?.contactDetails && !loading && (
            <div
              id="Contact"
              className="bg-[#fff9f1] p-2 sm:p-8 overflow-x-auto"
            >
              <h2 className="text-xl font-bold text-[#384f31] mb-4">Contact</h2>
              <p className="text-gray-800 mb-2">
                {data.contactDetails.contactLine}
              </p>
              <p className="text-gray-800 mb-2">

              <i className="fas fa-regular fa-envelope text-[#384f31]"></i> <a href={`mailto:${data.contactDetails.emailLink}`} target="_blank" rel="noreferrer"> {data.contactDetails.emailLink}</a>
             <br/>
                <i className="fas fa-brands fa-whatsapp text-[#384f31]"></i> 
                <a
                  href={data.contactDetails.whatsappUrl}
                  target="_blank"
                  rel="noreferrer"
                >
                  {data.contactDetails.whatsappNumber}
                </a>
              </p>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Usa;
